const API_URL = process.env.REACT_APP_API_URL || "https://api.what-to-do-app.com";

export default API_URL;
